import { connect } from 'react-redux';
import InfoHistory from './InfoHistory';
import { getInfoHistory } from '../../store/actions/infoHistory';

const mapStateToProps = ({
  userReducer,
  pieceInfoReducer,
  infoHistoryReducer
}) => ({
  userReducer,
  pieceInfoReducer,
  infoHistoryReducer
});

const mapDispatchToProps = { getInfoHistory };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InfoHistory);
